import { css } from 'lit';
/* eslint-disable max-lines */

import { QuantityType } from '../config/ConfigQuantityTypes';
import { Color } from '@typings/shared-types';
import { FormSectionsRecord } from './ConfigREM';

// TODO: Have the API provide as many event type related configurations as possible to avoid possible desyncs between the data and the frontend config
// List of all event types returned by the events/fields endpoint
export const EventTypes = {
  PERCENT_100_OF_LEGAL_LOAD_ALLOWED_ON_THE_DRIVE_AXLES_OF_LONG_COMBINATION_VEHICLES: '100 PERCENT OF LEGAL LOAD ALLOWED ON THE DRIVE AXLES OF LONG COMBINATION VEHICLES',
  ACCESS_TO_EMERGENCY_EVACUATION_LANES: 'ACCESS TO EMERGENCY EVACUATION LANES',
  ACID_SPILL: 'ACID SPILL',
  AIR_CRASH: 'AIR CRASH',
  AIRCRAFT_LANDING_ON_ROADWAY: 'AIRCRAFT LANDING ON ROADWAY',
  AIRSHOW: 'AIRSHOW',
  ALL_LANES_BLOCKED: 'ALL LANES BLOCKED',
  ANIMAL_CROSSING_AREA: 'ANIMAL CROSSING AREA',
  ANIMAL_ON_ROADWAY: 'ANIMAL ON ROADWAY',
  AUTOMOBILE_RACE: 'AUTOMOBILE RACE',
  AXLE_COUNT_LIMIT: 'AXLE COUNT LIMIT',
  AXLE_LOAD_LIMIT: 'AXLE LOAD LIMIT',
  BASEBALL_GAME: 'BASEBALL GAME',
  BASKETBALL_GAME: 'BASKETBALL GAME',
  BICYCLE_RACE: 'BICYCLE RACE',
  BICYCLISTS_ON_ROADWAY: 'BICYCLISTS ON ROADWAY',
  BLOCKED: 'BLOCKED',
  BOXING_MATCH: 'BOXING MATCH',
  BRIDGE_CONSTRUCTION: 'BRIDGE CONSTRUCTION',
  BRIDGE_DEMOLITION_WORK: 'BRIDGE DEMOLITION WORK',
  BRIDGE_INSPECTION_WORK: 'BRIDGE INSPECTION WORK',
  BRIDGE_IS_CLOSED: 'BRIDGE IS CLOSED',
  BRIDGE_MAINTENANCE_OPERATIONS: 'BRIDGE MAINTENANCE OPERATIONS',
  BROKEN_WATER_MAIN: 'BROKEN WATER MAIN',
  BRUSH_CONTROL: 'BRUSH CONTROL',
  BUILDING_FIRE: 'BUILDING FIRE',
  BUS_LANE_AVAILABLE_FOR_ALL_VEHICLES: 'BUS LANE AVAILABLE FOR ALL VEHICLES',
  BUS_STUCK_UNDER_BRIDGE: 'BUS STUCK UNDER BRIDGE',
  CARNIVAL: 'CARNIVAL',
  CARPOOL_LANE_AVAILABLE: 'CARPOOL LANE AVAILABLE',
  CARPOOL_RESTRICTIONS_CHANGED: 'CARPOOL RESTRICTIONS CHANGED',
  CARPOOL_RESTRICTIONS_LIFTED: 'CARPOOL RESTRICTIONS LIFTED',
  CHEMICAL_SPILL: 'CHEMICAL SPILL',
  CLEARANCE_WORK: 'CLEARANCE WORK',
  CLOSED: 'CLOSED',
  CLOSED_FOR_REPAIRS: 'CLOSED FOR REPAIRS',
  CLOSED_FOR_THE_SEASON: 'CLOSED FOR THE SEASON',
  CLOSED_INTERMITTENTLY: 'CLOSED INTERMITTENTLY',
  CLOSED_TO_ALL_TRAFFIC_EXCEPT_EMERGENCY_VEHICLES: 'CLOSED TO ALL TRAFFIC EXCEPT EMERGENCY VEHICLES',
  CLOSED_TO_TRAFFIC: 'CLOSED TO TRAFFIC',
  COLLAPSE: 'COLLAPSE',
  COLLAPSED_SEWER: 'COLLAPSED SEWER',
  CONCERT: 'CONCERT',
  CONSTRUCTION_TRAFFIC_MERGING: 'CONSTRUCTION TRAFFIC MERGING',
  CONSTRUCTION_WORK: 'CONSTRUCTION WORK',
  CONSIDER_ALTERNATE_ROUTE: 'CONSIDER ALTERNATE ROUTE',
  CRASH: 'CRASH',
  CRASH_INVESTIGATION_WORK: 'CRASH INVESTIGATION WORK',
  CROSS_STREET_CLOSED: 'CROSS STREET CLOSED',
  CROWD: 'CROWD',
  DAMAGE_TO_BRIDGE: 'DAMAGE TO BRIDGE',
  DEBRIS_ON_ROADWAY: 'DEBRIS ON ROADWAY',
  DELAYS: 'DELAYS',
  DERAILED_TRAIN: 'DERAILED TRAIN',
  DETOUR_IN_OPERATION: 'DETOUR IN OPERATION',
  DISABLED_TRAIN: 'DISABLED TRAIN',
  DISASTER_CLEARED: 'DISASTER CLEARED',
  DOG_SLED_RACE: 'DOG SLED RACE',
  DOWNED_CABLES: 'DOWNED CABLES',
  DOWNED_POWER_LINES: 'DOWNED POWER LINES',
  EMERGENCY_MAINTENANCE: 'EMERGENCY MAINTENANCE',
  EMERGENCY_REPAIRS: 'EMERGENCY REPAIRS',
  EMERGENCY_WEIGHT_LIMIT_100_PERCENT_OF_LEGAL_LOAD: 'EMERGENCY WEIGHT LIMIT 100 PERCENT OF LEGAL LOAD',
  EMERGENCY_WEIGHT_LIMIT_50_PERCENT_OF_LEGAL_LOAD: 'EMERGENCY WEIGHT LIMIT 50 PERCENT OF LEGAL LOAD',
  EMERGENCY_WEIGHT_LIMIT_75_PERCENT_OF_LEGAL_LOAD: 'EMERGENCY WEIGHT LIMIT 75 PERCENT OF LEGAL LOAD',
  EMERGENCY_WEIGHT_LIMIT_85_PERCENT_OF_LEGAL_LOAD: 'EMERGENCY WEIGHT LIMIT 85 PERCENT OF LEGAL LOAD',
  ENTRANCE_RAMP_BLOCKED: 'ENTRANCE RAMP BLOCKED',
  ENTRANCE_RAMP_CLOSED: 'ENTRANCE RAMP CLOSED',
  ENTRANCE_RAMP_PARTIALLY_BLOCKED: 'ENTRANCE RAMP PARTIALLY BLOCKED',
  ENTRANCE_RAMP_PARTIALLY_CLOSED: 'ENTRANCE RAMP PARTIALLY CLOSED',
  EVACUATION_TRAFFIC: 'EVACUATION TRAFFIC',
  EVENT_ENDED: 'EVENT ENDED',
  EXHIBITION: 'EXHIBITION',
  EXIT_RAMP_BLOCKED: 'EXIT RAMP BLOCKED',
  EXIT_RAMP_CLOSED: 'EXIT RAMP CLOSED',
  EXIT_RAMP_PARTIALLY_BLOCKED: 'EXIT RAMP PARTIALLY BLOCKED',
  EXIT_RAMP_PARTIALLY_CLOSED: 'EXIT RAMP PARTIALLY CLOSED',
  EXPLOSION: 'EXPLOSION',
  FAIR: 'FAIR',
  FALLEN_TREES: 'FALLEN TREES',
  FESTIVAL: 'FESTIVAL',
  FIRE: 'FIRE',
  FIREWORKS_DISPLAY: 'FIREWORKS DISPLAY',
  FLAMES_NEXT_TO_ROAD: 'FLAMES NEXT TO ROAD',
  FLASH_FLOOD: 'FLASH FLOOD',
  FLOOD_WATCH: 'FLOOD WATCH',
  FLOODING: 'FLOODING',
  FOOTBALL_GAME: 'FOOTBALL GAME',
  FOLLOW_LOCAL_DETOUR: 'FOLLOW LOCAL DETOUR',
  FUEL_SPILL: 'FUEL SPILL',
  FUNERAL_PROCESSION: 'FUNERAL PROCESSION',
  GAME: 'GAME',
  GAS_LEAK: 'GAS LEAK',
  GAS_MAIN_WORK: 'GAS MAIN WORK',
  GOLF_TOURNAMENT: 'GOLF TOURNAMENT',
  GRASS_FIRE: 'GRASS FIRE',
  GROSS_WEIGHT_LIMIT: 'GROSS WEIGHT LIMIT',
  HAZARDOUS_MATERIALS_SPILL: 'HAZARDOUS MATERIALS SPILL',
  HAZARDOUS_MATERIALS_TRUCK_RESTRICTION: 'HAZARDOUS MATERIALS TRUCK RESTRICTION',
  HEAD_TO_HEAD_TRAFFIC_ON_THE_ROADWAY: 'HEAD TO HEAD TRAFFIC ON THE ROADWAY',
  HEIGHT_LIMIT: 'HEIGHT LIMIT',
  HOCKEY_GAME: 'HOCKEY GAME',
  HOLIDAY_TRAFFIC: 'HOLIDAY TRAFFIC',
  HORSE_SHOW: 'HORSE SHOW',
  HOT_AIR_BALLOONING: 'HOT AIR BALLOONING',
  HOV_2_NO_SINGLE_OCCUPANT_VEHICLES: 'HOV 2 NO SINGLE OCCUPANT VEHICLES',
  HOV_3_NO_VEHICLES_WITH_LESS_THAN_THREE_OCCUPANTS: 'HOV 3 NO VEHICLES WITH LESS THAN THREE OCCUPANTS',
  INCIDENT: 'INCIDENT',
  INJURY_CRASH: 'INJURY CRASH',
  INTERMITTENT_LANE_CLOSURE: 'INTERMITTENT LANE CLOSURE',
  INTERSECTION_CLOSED: 'INTERSECTION CLOSED',
  INTERSECTION_PERMANENTLY_CLOSED: 'INTERSECTION PERMANENTLY CLOSED',
  JACKKNIFED_SEMI_TRAILER: 'JACKKNIFED SEMI TRAILER',
  JACKKNIFED_TRAILER: 'JACKKNIFED TRAILER',
  LANDSLIDE: 'LANDSLIDE',
  LANE_BLOCKED: 'LANE BLOCKED',
  LANE_CLOSED: 'LANE CLOSED',
  LANE_IS_CLOSED: 'LANE IS CLOSED',
  LANE_RESTRICTIONS_LIFTED: 'LANE RESTRICTIONS LIFTED',
  LEFT_LANE_OF_EXIT_RAMP_BLOCKED: 'LEFT LANE OF EXIT RAMP BLOCKED',
  LEFT_LANE_OF_EXIT_RAMP_CLOSED: 'LEFT LANE OF EXIT RAMP CLOSED',
  LEFT_TURN_LANE_CLOSED: 'LEFT TURN LANE CLOSED',
  LENGTH_LIMIT: 'LENGTH LIMIT',
  LEVEE_FAILURE: 'LEVEE FAILURE',
  LOCAL_ACCESS_ONLY: 'LOCAL ACCESS ONLY',
  LOOK_OUT_FOR_FLAGGER: 'LOOK OUT FOR FLAGGER',
  LONG_DELAYS: 'LONG DELAYS',
  LONG_COMBINATION_VEHICLES_PROHIBITED: 'LONG COMBINATION VEHICLES PROHIBITED',
  MAJOR_CONSTRUCTION_PROJECT: 'MAJOR CONSTRUCTION PROJECT',
  MAJOR_EVENT: 'MAJOR EVENT',
  MAJOR_FLOOD: 'MAJOR FLOOD',
  MAJOR_HAZARDOUS_MATERIALS_FIRE: 'MAJOR HAZARDOUS MATERIALS FIRE',
  MAJOR_HAZARDOUS_MATERIALS_RELEASE: 'MAJOR HAZARDOUS MATERIALS RELEASE',
  MARATHON: 'MARATHON',
  MEDICAL_EMERGENCY: 'MEDICAL EMERGENCY',
  MINOR_CRASH: 'MINOR CRASH',
  MOBILE_MAINTENANCE_OPERATIONS: 'MOBILE MAINTENANCE OPERATIONS',
  MOTOR_VEHICLE_RESTRICTIONS_LIFTED: 'MOTOR VEHICLE RESTRICTIONS LIFTED',
  MOVIE_FILMING: 'MOVIE FILMING',
  MUDSLIDE: 'MUDSLIDE',
  MUDSLIDE_DANGER: 'MUDSLIDE DANGER',
  MULTI_VEHICLE_CRASH: 'MULTI VEHICLE CRASH',
  MUSIC_FESTIVAL: 'MUSIC FESTIVAL',
  NARROW_LANES: 'NARROW LANES',
  NEW_ROAD_CONSTRUCTION_LAYOUT: 'NEW ROAD CONSTRUCTION LAYOUT',
  NIGHT_TIME_CONSTRUCTION_WORK: 'NIGHT TIME CONSTRUCTION WORK',
  NO_COMMERCIAL_TRAILER_TRAFFIC: 'NO COMMERCIAL TRAILER TRAFFIC',
  NO_HIGH_PROFILE_VEHICLES: 'NO HIGH PROFILE VEHICLES',
  NO_MOTOR_VEHICLES: 'NO MOTOR VEHICLES',
  NO_OVERLOADS: 'NO OVERLOADS',
  NO_THROUGH_TRAFFIC: 'NO THROUGH TRAFFIC',
  NO_TRAILERS: 'NO TRAILERS',
  NOISE_RESTRICTION: 'NOISE RESTRICTION',
  NUMEROUS_CRASHES: 'NUMEROUS CRASHES',
  OBSTRUCTION_CLEARED: 'OBSTRUCTION CLEARED',
  OIL_SPILL: 'OIL SPILL',
  OPPOSING_LANES_REVERSED_FOR_EVACUATION: 'OPPOSING LANES REVERSED FOR EVACUATION',
  OUT: 'OUT',
  OUTDOOR_MARKET: 'OUTDOOR MARKET',
  PARADE: 'PARADE',
  PAVEMENT_BUCKLED: 'PAVEMENT BUCKLED',
  PAVING_OPERATIONS: 'PAVING OPERATIONS',
  PEOPLE_ON_ROADWAY: 'PEOPLE ON ROADWAY',
  PERMITS_CALL_IN_BASIS: 'PERMITS CALL IN BASIS',
  PERMITS_CLOSED: 'PERMITS CLOSED',
  PERMITS_TEMPORARILY_CLOSED: 'PERMITS TEMPORARILY CLOSED',
  PERMITTED_OVERSIZE_LOADS_PROHIBITED: 'PERMITTED OVERSIZE LOADS PROHIBITED',
  PILOT_CAR_IN_OPERATION: 'PILOT CAR IN OPERATION',
  POLICE_ACTIVITY: 'POLICE ACTIVITY',
  PORTABLE_TRAFFIC_SIGNALS_IN_USE: 'PORTABLE TRAFFIC SIGNALS IN USE',
  POSTED_BRIDGE: 'POSTED BRIDGE',
  POTHOLE: 'POTHOLE',
  PRESIDENTIAL_VISIT: 'PRESIDENTIAL VISIT',
  PROCESSION: 'PROCESSION',
  RACE_EVENT: 'RACE EVENT',
  RADIATION_HAZARD: 'RADIATION HAZARD',
  RADIOACTIVE_RELEASE: 'RADIOACTIVE RELEASE',
  RAIL_CRASH: 'RAIL CRASH',
  RAILROAD_CROSSING_CLOSED: 'RAILROAD CROSSING CLOSED',
  RAMP_IS_BLOCKED: 'RAMP IS BLOCKED',
  RAMP_PARTIALLY_BLOCKED: 'RAMP PARTIALLY BLOCKED',
  RAMP_PARTIALLY_CLOSED: 'RAMP PARTIALLY CLOSED',
  RAMP_RESTRICTIONS: 'RAMP RESTRICTIONS',
  RAMP_RESTRICTIONS_LIFTED: 'RAMP RESTRICTIONS LIFTED',
  REACTOR_LEAKAGE: 'REACTOR LEAKAGE',
  REDUCED_TO_ONE_LANE: 'REDUCED TO ONE LANE',
  REDUCED_TO_THREE_LANES: 'REDUCED TO THREE LANES',
  REDUCED_TO_TWO_LANES: 'REDUCED TO TWO LANES',
  REOPENED_TO_TRAFFIC: 'REOPENED TO TRAFFIC',
  RESERVOIR_FAILURE: 'RESERVOIR FAILURE',
  REST_AREA_CLOSED: 'REST AREA CLOSED',
  RESTRICTIONS: 'RESTRICTIONS',
  RESTRICTIONS_FOR_HIGH_PROFILE_VEHICLES_LIFTED: 'RESTRICTIONS FOR HIGH PROFILE VEHICLES LIFTED',
  RESTRICTIONS_LIFTED: 'RESTRICTIONS LIFTED',
  RIGHT_LANE_OF_EXIT_RAMP_BLOCKED: 'RIGHT LANE OF EXIT RAMP BLOCKED',
  RIGHT_LANE_OF_EXIT_RAMP_CLOSED: 'RIGHT LANE OF EXIT RAMP CLOSED',
  RIGHT_TURN_LANE_CLOSED: 'RIGHT TURN LANE CLOSED',
  ROAD_CLOSURE: 'ROAD CLOSURE',
  ROAD_CONSTRUCTION: 'ROAD CONSTRUCTION',
  ROAD_MAINTENANCE_OPERATIONS: 'ROAD MAINTENANCE OPERATIONS',
  ROAD_RACE: 'ROAD RACE',
  ROAD_RECONSTRUCTION: 'ROAD RECONSTRUCTION',
  ROAD_SURFACE_COLLAPSE: 'ROAD SURFACE COLLAPSE',
  ROCK_FALL: 'ROCK FALL',
  ROCK_FALL_DANGER: 'ROCK FALL DANGER',
  RODEO: 'RODEO',
  ROUGH_ROAD: 'ROUGH ROAD',
  ROUNDABOUT: 'ROUNDABOUT',
  SEASONAL_WEIGHT_LIMIT_100_PERCENT_OF_LEGAL_LOAD: 'SEASONAL WEIGHT LIMIT 100 PERCENT OF LEGAL LOAD',
  SEASONAL_WEIGHT_LIMIT_50_PERCENT_OF_LEGAL_LOAD: 'SEASONAL WEIGHT LIMIT 50 PERCENT OF LEGAL LOAD',
  SEASONAL_WEIGHT_LIMIT_75_PERCENT_OF_LEGAL_LOAD: 'SEASONAL WEIGHT LIMIT 75 PERCENT OF LEGAL LOAD',
  SEASONAL_WEIGHT_LIMIT_85_PERCENT_OF_LEGAL_LOAD: 'SEASONAL WEIGHT LIMIT 85 PERCENT OF LEGAL LOAD',
  SERIOUS_CRASH: 'SERIOUS CRASH',
  SEWER_OVERFLOW: 'SEWER OVERFLOW',
  SHORT_DELAYS: 'SHORT DELAYS',
  SHOULDER_CLOSED: 'SHOULDER CLOSED',
  SHOW: 'SHOW',
  SINGLE_LANE_TRAFFIC_ALTERNATING_DIRECTIONS: 'SINGLE LANE TRAFFIC ALTERNATING DIRECTIONS',
  SNOWMELT: 'SNOWMELT',
  SOCCER_GAME: 'SOCCER GAME',
  SPECIAL_EVENT: 'SPECIAL EVENT',
  SPEED_RESTRICTION: 'SPEED RESTRICTION',
  SPILLED_LOAD: 'SPILLED LOAD',
  SPORTING_EVENT_ENDED: 'SPORTING EVENT ENDED',
  SPORTS_EVENT: 'SPORTS EVENT',
  STALLED_VEHICLE: 'STALLED VEHICLE',
  STALLED_VEHICLE_BLOCKING: 'STALLED VEHICLE BLOCKING',
  STATE_OCCASION: 'STATE OCCASION',
  SUBSIDENCE: 'SUBSIDENCE',
  TEMPORARY_TRAFFIC_LIGHTS: 'TEMPORARY TRAFFIC LIGHTS',
  TENNIS_TOURNAMENT: 'TENNIS TOURNAMENT',
  TOTAL_SOLAR_ECLIPSE: 'TOTAL SOLAR ECLIPSE',
  TOURNAMENT: 'TOURNAMENT',
  TOWING_SERVICES_PROHIBITED: 'TOWING SERVICES PROHIBITED',
  TOXIC_LEAK: 'TOXIC LEAK',
  TOXIC_RELEASE: 'TOXIC RELEASE',
  TOXIC_SPILL: 'TOXIC SPILL',
  TRACK_AND_FIELD_EVENT: 'TRACK AND FIELD EVENT',
  TRADE_EXPO: 'TRADE EXPO',
  TRAFFIC_HELD_EXPECT_DELAYS: 'TRAFFIC HELD. EXPECT DELAYS',
  TRAFFIC_INCIDENT: 'TRAFFIC INCIDENT',
  TRAFFIC_REGULATIONS_HAVE_BEEN_CHANGED: 'TRAFFIC REGULATIONS HAVE BEEN CHANGED',
  TRUCK_LANE_AVAILABLE_FOR_ALL_VEHICLES: 'TRUCK LANE AVAILABLE FOR ALL VEHICLES',
  TRUCK_RESTRICTION: 'TRUCK RESTRICTION',
  TRUCK_STUCK_UNDER_BRIDGE: 'TRUCK STUCK UNDER BRIDGE',
  TRUCKER_INFO: 'TRUCKER INFO',
  TWO_LEFT_LANES_OF_EXIT_RAMP_BLOCKED: 'TWO LEFT LANES OF EXIT RAMP BLOCKED',
  TWO_RIGHT_LANES_OF_EXIT_RAMP_BLOCKED: 'TWO RIGHT LANES OF EXIT RAMP BLOCKED',
  UTILITY_WORK: 'UTILITY WORK',
  VEHICLE_FIRE: 'VEHICLE FIRE',
  FIRE: 'FIRE',
  VEHICLE_SPUN_OUT: 'VEHICLE SPUN OUT',
  VIP_VISIT: 'VIP VISIT',
  WATER_MAIN_WORK: 'WATER MAIN WORK',
  WATER_SPORTS_EVENT: 'WATER SPORTS EVENT',
  WIDTH_LIMIT: 'WIDTH LIMIT',
  WILDFIRE: 'WILDFIRE',
  WINTER_SPORTS_EVENT: 'WINTER SPORTS EVENT',
  WORK_IN_THE_MEDIAN: 'WORK IN THE MEDIAN',
  WORK_ON_THE_SHOULDER: 'WORK ON THE SHOULDER',
  WORK_ON_UNDERGROUND_CABLES: 'WORK ON UNDERGROUND CABLES',
  WORK_ON_UNDERGROUND_SERVICES: 'WORK ON UNDERGROUND SERVICES',
  WORKERS_ARE_PRESENT: 'WORKERS ARE PRESENT',
  WORK_ZONE_IS_ACTIVE: 'WORK ZONE IS ACTIVE',
  WRESTLING_MATCH: 'WRESTLING MATCH',  
} as const;

enum RespondingUnitType {
	FIRE_DEPARTMENT = 'FIRE DEPARTMENT',
	EMS = 'EMS, EMERGENCY, MEDICAL SERVICES',
	CORONER = 'CORONER, MEDICAL, CORONER',
	CONSTRUCTION = 'CONSTRUCTION',
	ISP = 'ISP, STATE POLICE',
	HEALTH_DEPT = 'HEALTH DEPT',
	HAZMAT_RESPONSE = 'HAZMAT RESPONSE',
	BRIDGE = 'BRIDGE, INDOT, BRIDGE INSPECTOR',
	HOOSIER_HELPER = 'HOOSIER HELPER',
	VINCENNES_DISTRICT = 'VINCENNES DISTRICT',
	GREENFIELD_DISTRICT = 'GREENFIELD DISTRICT',
	CRAWFORDSVILLE_DISTRICT = 'CRAWFORDSVILLE DISTRICT',
	TMC_DISPATCHER = 'TMC DISPATCHER',
	SEYMOUR_DISTRICT = 'SEYMOUR DISTRICT',
	MEDEVAC = 'MEDEVAC/LIFELINE AIR AMBULANCE',
	MAINTENANCE = 'MAINTENANCE',
	SPILL_RECOVERY = 'SPILL, RECOVERY',
	SIGNAL_TECH = 'SIGNAL, SIGNAL, TECH',
	LOCAL_CITY_COUNTY_POLICE = 'LOCAL CITY/COUNTY POLICE',
	PENDING_UNIT = 'PENDING UNIT',
	FT_WAYNE_DISTRICT = 'FT WAYNE DISTRICT',
	LAPORTE_DISTRICT = 'LAPORTE DISTRICT',
	ATIS_ADMINISTRATOR = 'ATIS ADMINISTRATOR/CUSTOM MESSAGE',
	WRECKER = 'WRECKER',
}

enum RespondingUnitDispositionType {
	AMA = 'AMA - AUTOMATED MESSAGE ACTIVATION',
	AVT = 'AVT - ABANDONED VEHICLE TAGGED',
	CMO = 'CMO - CALLED TO MAKE OWN ARRANGEMENTS',
	CMS = 'CMS - CUSTOM MESSAGE SCHEDULED (NOT AUTOMATED)',
	DCC = 'DCC - DUPLICATED CARD CANCELLED',
	DDO = 'DDO - DISREGARDED, MOTORIST DROVE OFF',
	DFV = 'DFV - DISPATCHED FOR FIELD VERIFICATION',
	DIO = 'DIO - DISPATCHED FOR INFORMATION ONLY',
	DNN = 'DNN - DISREGARD, NOT NEEDED',
	DNR = 'DNR - DID NOT RESPOND',
	DOS = 'DOS - MOTORIST DROVE OFF WHILE TECH ON-SITE',
	EEI = 'EEI - ERRANT ENTRY IGNORE',
	EFR = 'EFR - ESCORTED FROM ROADWAY',
	EMP = 'EMP - EMERGENCY PATCHING',
	FAA = 'FAA - FIRST AID ADMINISTERED',
	FMD = 'FMD - FUEL MOTORIST VEHICLE (DIESEL)',
	FMG = 'FMG - FUEL MOTORIST VEHICLE (GAS)',
	FSP = 'FSP - FIRE SUPPRESSION',
	HAZ = 'HAZ - HAZARDOUS RESPONSE OR CONTAINMENT / OIL DRY',
	INF = 'INF - INFORMATION / DIRECTIONS GIVEN',
	JMP = 'JMP - JUMP STARTED VEHICLE',
	MCP = 'MCP - MOTORIST ON CELL PHONE',
	MVR = 'MVR - MINOR VEHICLE REPAIR',
	NPS = 'NPS - NOTIFICATION PAGE SENT',
	NRE = 'NRE - NO REPORT (ONLY OBSERVED) EVENT (IN PROGRESS)',
	OTR = 'OTR - OTHER DISPOSITON',
	RAS = 'RAS - REFUSED ASSISTANCE',
	RIS = 'RIS - REMOVED ILLEGAL SIGN',
	RRW = 'RRW - RELOCATED TO / FROM ROADWAY',
	RTA = 'RTA - REFERRED TO ANOTHER AGENCY',
	RTD = 'RTD - REFERRED TO TECH DEPLOYMENT DIVISION',
	RTK = 'RTK - REPORT TAKEN',
	RXS = 'RXS - REQUESTED EXTERNAL SERVICES',
	SLD = 'SLD - SECURE LOAD',
	SMD = 'SMD - SLEEPING MOTORIST DROVE OFF',
	TCH = 'TCH - TIRE CHANGE',
	TFC = 'TFC - TRAFFIC CONTROL',
	TOC = 'TOC - TOWED FROM SCENE, OWNER CALLED',
	TPC = 'TPC - TOWED FROM SCENE, POLICE CALLED',
	TRN = 'TRN - TRAINING EVENT (PROVIDING OR RECEIVING)',
	UTL = 'UTL - UNABLE TO LOCATE',
	WCK = 'WCK - WELFARE CHECK',
	WPV = 'WPV - WATER / COOLANT PROVIDED IN VEHICLE',
}

export type EventType = typeof EventTypes[keyof typeof EventTypes];

interface EventTypeConfigOptions {
	// if true, events with this headline phrase will display on 511 by default
	importTo511: boolean;
	// phrase will display in this color in the descriptors list
	color?: Color | null;
	// user will be prompted to enter the specified restriction if the phrase is selected
	restriction?: QuantityType | null;
	// specify if dms, vehicles, and responding units sections should display by default
	defaultFormSections?: Partial<FormSectionsRecord<boolean>>;
	// suggested responding unit types and their corresponding suggested dispositions
	// if unspecified, all types and dispositions will be suggested
	// so far only used by INDOT
	respondingUnitSuggestions?: Record<string, string[]>;
	// if true, user will be prompted to enter an end date before saving the event
	shouldHaveEndDate?: boolean;
	// if true, this event type will be available in the work zone request tool
	isWorkZonePhrase?: boolean;
	// if true, this event type CANNOT be entered as a cause
	cannotBeCause?: boolean;
	// if true, this event type can only be a headline phrase for work zone requests
	isWorkZoneHeadlinePhrase?: boolean;
	// if true, this event type can only be a secondary phrase for work zone requests
	// if both isWorkZoneHeadlinePhrase and isWorkZoneSecondaryPhrase are left undefined, the event type can be used as either a headline or a secondary phrase
	isWorkZoneSecondaryPhrase?: boolean;
	// if true, events of this type will be set to priority 1 when all lanes in a direction are closed
	unplannedEvent?: boolean;
	// if true, user will be reminded to add the FHWA email group if the phrase is selected
	triggersFHWAReminder?: boolean;
}

// example empty config entry with minimum info:
// [EventTypes.NEW_EVENT_TYPE]: {
// 		importTo511: false,
// }

// example config entry with all info specified
// [EventTypes.NEW_EVENT_TYPE]: {
// 		importTo511: false,
// 		color: NON_HEADLINE_PHRASE_COLOR,
// 		restriction: null,
// 		defaultFormSections: {
// 			DMS: false,
// 			VEHICLES: false,
// 			RESPONDING_UNITS: true,
// 		},
// 		respondingUnitSuggestions: {
// 			[RespondingUnitType.HOOSIER_HELPER]: [
// 				RespondingUnitDispositionType.DFV,
// 				RespondingUnitDispositionType.DNN,
// 				RespondingUnitDispositionType.TFC,
// 			],
// 		},
// 		shouldHaveEndDate: true,
// 		isWorkZonePhrase: true,
// 		cannotBeCause: true,
// 		cannotBeHeadline: false,
// 	},

const NON_HEADLINE_PHRASE_COLOR: Color = '#1267e4';

export const EventTypeConfig: Partial<Record<EventType, EventTypeConfigOptions>> = {
  [EventTypes.ACCESS_TO_EMERGENCY_EVACUATION_LANES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MEDICAL_EMERGENCY]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.INCIDENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.STALLED_VEHICLE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DISABLED_TRAIN]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.VEHICLE_SPUN_OUT]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
    [EventTypes.VEHICLE_FIRE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RIGHT_TURN_LANE_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.JACKKNIFED_SEMI_TRAILER]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.JACKKNIFED_TRAILER]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ACID_SPILL]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CHEMICAL_SPILL]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FUEL_SPILL]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HAZARDOUS_MATERIALS_SPILL]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.OIL_SPILL]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SPILLED_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TOXIC_SPILL]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DERAILED_TRAIN]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRUCK_STUCK_UNDER_BRIDGE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BUS_STUCK_UNDER_BRIDGE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CRASH]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SERIOUS_CRASH]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.INJURY_CRASH]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MINOR_CRASH]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MULTI_VEHICLE_CRASH]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NUMEROUS_CRASHES]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CRASH_INVESTIGATION_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRAFFIC_INCIDENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CLOSED_TO_TRAFFIC]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
    [EventTypes.CLOSED_INTERMITTENTLY]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.CONSIDER_ALTERNATE_ROUTE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    cannotBeCause: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
   [EventTypes.CLOSED_FOR_REPAIRS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CLOSED_FOR_THE_SEASON]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.REDUCED_TO_ONE_LANE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.REDUCED_TO_TWO_LANES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.REDUCED_TO_THREE_LANES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.COLLAPSE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.OUT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.REOPENED_TO_TRAFFIC]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EXIT_RAMP_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.ENTRANCE_RAMP_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.REST_AREA_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RIGHT_LANE_OF_EXIT_RAMP_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TWO_RIGHT_LANES_OF_EXIT_RAMP_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LEFT_LANE_OF_EXIT_RAMP_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
    [EventTypes.LANE_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: false,
  },
  [EventTypes.TWO_LEFT_LANES_OF_EXIT_RAMP_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LANE_IS_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: false,
  },
  [EventTypes.BRIDGE_IS_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.RAMP_IS_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CLOSED_TO_ALL_TRAFFIC_EXCEPT_EMERGENCY_VEHICLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ALL_LANES_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LEFT_LANE_OF_EXIT_RAMP_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RIGHT_LANE_OF_EXIT_RAMP_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DETOUR_IN_OPERATION]: {
    importTo511: true,
    color: null,
    restriction: null,
      defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    cannotBeCause: false,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.ROAD_CLOSURE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: false,
  },
  [EventTypes.LANE_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.INTERMITTENT_LANE_CLOSURE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.SHOULDER_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.ENTRANCE_RAMP_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EXIT_RAMP_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RAMP_PARTIALLY_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ENTRANCE_RAMP_PARTIALLY_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EXIT_RAMP_PARTIALLY_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.INTERSECTION_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
    [EventTypes.POLICE_ACTIVITY]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.INTERSECTION_PERMANENTLY_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CROSS_STREET_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROAD_CONSTRUCTION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CONSTRUCTION_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: false,
  },
  [EventTypes.PAVING_OPERATIONS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.WORK_IN_THE_MEDIAN]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROAD_RECONSTRUCTION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NARROW_LANES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CONSTRUCTION_TRAFFIC_MERGING]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROAD_MAINTENANCE_OPERATIONS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: true,
  },
  [EventTypes.BRIDGE_MAINTENANCE_OPERATIONS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: true,
  },
  [EventTypes.BRIDGE_CONSTRUCTION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: true,
  },
  [EventTypes.BRIDGE_DEMOLITION_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WATER_MAIN_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.GAS_MAIN_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WORK_ON_UNDERGROUND_CABLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WORK_ON_UNDERGROUND_SERVICES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NEW_ROAD_CONSTRUCTION_LAYOUT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TEMPORARY_TRAFFIC_LIGHTS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EMERGENCY_MAINTENANCE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BRIDGE_INSPECTION_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NIGHT_TIME_CONSTRUCTION_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: true,
  },
  [EventTypes.WORK_ON_THE_SHOULDER]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EMERGENCY_REPAIRS]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.UTILITY_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: true,
  },
  [EventTypes.BRUSH_CONTROL]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HEAD_TO_HEAD_TRAFFIC_ON_THE_ROADWAY]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.PORTABLE_TRAFFIC_SIGNALS_IN_USE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.SINGLE_LANE_TRAFFIC_ALTERNATING_DIRECTIONS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.MAJOR_CONSTRUCTION_PROJECT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DEBRIS_ON_ROADWAY]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PEOPLE_ON_ROADWAY]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BICYCLISTS_ON_ROADWAY]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ANIMAL_ON_ROADWAY]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FALLEN_TREES]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DOWNED_POWER_LINES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DOWNED_CABLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SUBSIDENCE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROAD_SURFACE_COLLAPSE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PAVEMENT_BUCKLED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.POTHOLE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FLOODING]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BROKEN_WATER_MAIN]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.COLLAPSED_SEWER]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SEWER_OVERFLOW]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.GAS_LEAK]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SNOWMELT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MUDSLIDE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROCK_FALL]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LANDSLIDE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CLEARANCE_WORK]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.OBSTRUCTION_CLEARED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ANIMAL_CROSSING_AREA]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DAMAGE_TO_BRIDGE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RAMP_PARTIALLY_BLOCKED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MUDSLIDE_DANGER]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROCK_FALL_DANGER]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROUGH_ROAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RESTRICTIONS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RAMP_RESTRICTIONS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRUCK_RESTRICTION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SPEED_RESTRICTION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.NOISE_RESTRICTION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRAFFIC_REGULATIONS_HAVE_BEEN_CHANGED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LOCAL_ACCESS_ONLY]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NO_TRAILERS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NO_HIGH_PROFILE_VEHICLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HAZARDOUS_MATERIALS_TRUCK_RESTRICTION]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NO_THROUGH_TRAFFIC]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NO_MOTOR_VEHICLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WIDTH_LIMIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.HEIGHT_LIMIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.LENGTH_LIMIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.AXLE_LOAD_LIMIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.GROSS_WEIGHT_LIMIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.AXLE_COUNT_LIMIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CARPOOL_LANE_AVAILABLE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CARPOOL_RESTRICTIONS_CHANGED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HOV_2_NO_SINGLE_OCCUPANT_VEHICLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HOV_3_NO_VEHICLES_WITH_LESS_THAN_THREE_OCCUPANTS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BUS_LANE_AVAILABLE_FOR_ALL_VEHICLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRUCK_LANE_AVAILABLE_FOR_ALL_VEHICLES]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PERMITS_CALL_IN_BASIS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PERMITS_TEMPORARILY_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PERMITS_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RESTRICTIONS_FOR_HIGH_PROFILE_VEHICLES_LIFTED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CARPOOL_RESTRICTIONS_LIFTED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LANE_RESTRICTIONS_LIFTED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RAMP_RESTRICTIONS_LIFTED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MOTOR_VEHICLE_RESTRICTIONS_LIFTED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RESTRICTIONS_LIFTED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TOWING_SERVICES_PROHIBITED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SEASONAL_WEIGHT_LIMIT_50_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SEASONAL_WEIGHT_LIMIT_75_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SEASONAL_WEIGHT_LIMIT_85_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SEASONAL_WEIGHT_LIMIT_100_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NO_OVERLOADS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LONG_COMBINATION_VEHICLES_PROHIBITED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PERMITTED_OVERSIZE_LOADS_PROHIBITED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.NO_COMMERCIAL_TRAILER_TRAFFIC]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.POSTED_BRIDGE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRUCKER_INFO]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROUNDABOUT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FLASH_FLOOD]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MAJOR_FLOOD]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RESERVOIR_FAILURE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LEVEE_FAILURE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WILDFIRE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BUILDING_FIRE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.GRASS_FIRE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.AIR_CRASH]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RAIL_CRASH]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TOXIC_RELEASE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TOXIC_LEAK]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RADIOACTIVE_RELEASE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RADIATION_HAZARD]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.REACTOR_LEAKAGE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EXPLOSION]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MAJOR_HAZARDOUS_MATERIALS_FIRE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MAJOR_HAZARDOUS_MATERIALS_RELEASE]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DISASTER_CLEARED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FLOOD_WATCH]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.AIRCRAFT_LANDING_ON_ROADWAY]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EVACUATION_TRAFFIC]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.OPPOSING_LANES_REVERSED_FOR_EVACUATION]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FLAMES_NEXT_TO_ROAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SPORTS_EVENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.GAME]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TOURNAMENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRACK_AND_FIELD_EVENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BASEBALL_GAME]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BASKETBALL_GAME]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BOXING_MATCH]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FOOTBALL_GAME]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SOCCER_GAME]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.GOLF_TOURNAMENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HOCKEY_GAME]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TENNIS_TOURNAMENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WRESTLING_MATCH]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ROAD_RACE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.AUTOMOBILE_RACE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.BICYCLE_RACE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RACE_EVENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MARATHON]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HORSE_SHOW]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.RODEO]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WATER_SPORTS_EVENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WINTER_SPORTS_EVENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SPORTING_EVENT_ENDED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.DOG_SLED_RACE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MAJOR_EVENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.AIRSHOW]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HOT_AIR_BALLOONING]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CONCERT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.STATE_OCCASION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.VIP_VISIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SHOW]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FESTIVAL]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EXHIBITION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.OUTDOOR_MARKET]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FAIR]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CARNIVAL]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FIREWORKS_DISPLAY]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TRADE_EXPO]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.MOVIE_FILMING]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PRESIDENTIAL_VISIT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.PARADE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.PROCESSION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.FUNERAL_PROCESSION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.CROWD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.HOLIDAY_TRAFFIC]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.TOTAL_SOLAR_ECLIPSE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EVENT_ENDED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.SPECIAL_EVENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: true,
  },
  [EventTypes.MUSIC_FESTIVAL]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EMERGENCY_WEIGHT_LIMIT_100_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EMERGENCY_WEIGHT_LIMIT_50_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EMERGENCY_WEIGHT_LIMIT_85_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EMERGENCY_WEIGHT_LIMIT_75_PERCENT_OF_LEGAL_LOAD]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.ENTRANCE_RAMP_PARTIALLY_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.EXIT_RAMP_PARTIALLY_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.LEFT_TURN_LANE_CLOSED]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.PERCENT_100_OF_LEGAL_LOAD_ALLOWED_ON_THE_DRIVE_AXLES_OF_LONG_COMBINATION_VEHICLES]:
    {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
      shouldHaveEndDate: true,
    },
  [EventTypes.STALLED_VEHICLE_BLOCKING]: {
    importTo511: true,
    color: null,
    restriction: null,
    unplannedEvent: true,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
  [EventTypes.WORKERS_ARE_PRESENT]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    cannotBeCause: true,
  },
  [EventTypes.WORK_ZONE_IS_ACTIVE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
  },
    [EventTypes.DELAYS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    cannotBeCause: false,

  },
  [EventTypes.SHORT_DELAYS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.DELAYS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
    cannotBeCause: false,
  },
   [EventTypes.TRAFFIC_HELD_EXPECT_DELAYS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.MOBILE_MAINTENANCE_OPERATIONS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: true,
    cannotBeCause: true,
  },
  [EventTypes.PILOT_CAR_IN_OPERATION]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    cannotBeCause: true,
    isWorkZonePhrase: true,
    isWorkZoneHeadlinePhrase: false,
    isWorkZoneSecondaryPhrase: true,
  },
  [EventTypes.LOOK_OUT_FOR_FLAGGER]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    cannotBeCause: true,
    isWorkZonePhrase: true,
    isWorkZoneSecondaryPhrase: true,
    isWorkZoneHeadlinePhrase: false,
  },
  [EventTypes.LONG_DELAYS]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: false,
  },
    [EventTypes.FIRE]: {
    importTo511: true,
    color: null,
    restriction: null,
    defaultFormSections: {
      DMS: false,
      VEHICLES: false,
      RESPONDING_UNITS: false,
    },
    respondingUnitSuggestions: {},
    shouldHaveEndDate: true,
    isWorkZonePhrase: false,
  },
};
 
